<div class="card d-flex flex-column justify-content-start align-items-start h-100 w-100 p-4">

    <div class="w-100 mb-2">
        <span class="text-primary-color fw-bolder">{{labels.codeDiscountSelectorLabel}}</span>
    </div>

    <input type="text" pInputText class="w-100 mb-1"
        [(ngModel)]="writtenCode"
        (ngModelChange)="onWrittenCodeChange()"/>

    <div class="d-flex flex-column justify-content-center align-items-start w-100">

        <button type="button" class="btn button-accent-color w-100 py-2"
            [disabled]="writtenCode === null || writtenCode === ''"
            (click)="applyWrittenCodeButtonClick()">

            <div class="w-100">
                <span class="fs-6">{{labels.codeDiscountButtonLabel}}</span>
            </div>

        </button>

    </div>

    <div *ngIf="showWrittenDiscountCodeError" class="alert alert-warning w-100 my-2" role="alert">
        <span>{{writtenDiscountCodeError}}</span>
    </div>

    <div *ngIf="writtenCodes && writtenCodes.length > 0" class="w-100">

        <div class="d-flex flex-wrap flex-row justify-content-start align-items-center w-100 my-2">

            <div class="w-100 mb-2">
                <span class="text-primary-color fw-bolder">{{labels.codeDiscountSelecedLabel}}</span>
            </div>
            <div class="card d-flex flex-row justify-content-start align-items-center w-100 p-2">
                <p-chip *ngFor="let code of writtenCodes"
                    class="me-2"
                    [label]="code"
                    [removable]="true"
                    (onRemove)="onRemoveWrittenCode(code)">
                </p-chip>
            </div>

        </div>

    </div>

</div>
